import IDirecionarCargasRequest from '../entities/IDirecionarCargasRequest'
import IDirecionarCargasResponse from '../entities/IDirecionarCargasResponse'
import { ILoteRepository } from '../repositories/ILoteRepository'

export interface IDirecionarCargas {
  execute(params: IDirecionarCargasRequest): Promise<IDirecionarCargasResponse>
}

export default class DirecionarCargasImpl implements IDirecionarCargas {
  constructor(private readonly lotesRepository: ILoteRepository) {}

  public async execute(
    params: IDirecionarCargasRequest,
  ): Promise<IDirecionarCargasResponse> {
    const response = await this.lotesRepository.direcionarCargas(params)
    return response
  }
}
